module.exports = __webpack_public_path__ + "img/svg/icon-hand.7de15d023b5efa5f9100b45933a712e3.svg";